import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "i18n-fe";
import PlacedByDivisionImpact from "./PlacedByDivisionImpact";

// #3405 -- the single-class confirm shown before the class drawer's Placed by
// division switch is sent, but only for a class that already has placings
// (ClassManager decides; it never mounts this for an unplaced class). The
// bulk dialog carries the same PlacedByDivisionImpact inside its own existing
// confirm instead of stacking a second one.
export default function PlacedByDivisionConfirmDialog({
  classes,
  loadPublished,
  saving,
  onCancel,
  onConfirm,
  // #3415: the same confirm serves Places awarded (the same re-place), with its
  // own static copy. Keys are passed whole so they stay static at the call site.
  titleKey = "ring.placedByDivisionConfirmTitle",
  warningKey,
}) {
  const { t } = useTranslation("scoreadmin");
  return (
    <Dialog
      open
      onClose={saving ? undefined : onCancel}
      maxWidth="sm"
      fullWidth
      data-testid="placed-by-division-confirm-dialog"
      sx={{ zIndex: (theme) => theme.zIndex.modal + 300 }}
    >
      <DialogTitle>{t(titleKey)}</DialogTitle>
      <DialogContent>
        <PlacedByDivisionImpact classes={classes} loadPublished={loadPublished} testIdBase="placed-by-division" warningKey={warningKey} />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={saving} sx={{ color: "text.primary" }} data-testid="placed-by-division-confirm-cancel">
          {t("ring.placedByDivisionConfirmCancel")}
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={saving} data-testid="placed-by-division-confirm-button">
          {t("ring.placedByDivisionConfirmButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
